import TestSelectors from '@racemap/utilities/consts/test_selectors';
import type { MenuProps } from 'antd';
import { type ReactNode, useState } from 'react';
import { Link } from 'react-router';
import { useIsAdmin } from 'src/lib/customHooks/useIsAdmin';
import { ImpersonateUserModal } from './ImpersonateUserModal';

export const useAdminMenuItems = (): {
  items: NonNullable<MenuProps['items']>;
  impersonateUserModal: ReactNode;
} => {
  const isAdmin = useIsAdmin();
  const [impersonateModalOpen, setImpersonateModalOpen] = useState(false);

  if (!isAdmin) return { items: [], impersonateUserModal: null };

  const items: NonNullable<MenuProps['items']> = [
    {
      key: '/admin/users',
      label: (
        <Link to="/admin/users" id={TestSelectors.admin.nav.sections.users.toString()}>
          Users
        </Link>
      ),
    },
    {
      key: '/admin/events/manage',
      label: (
        <Link to="/admin/events/manage" id={TestSelectors.admin.nav.sections.events.toString()}>
          Events
        </Link>
      ),
    },
    {
      key: '/admin/billing/report',
      label: (
        <Link to="/admin/billing/report" id={TestSelectors.admin.nav.sections.billing.toString()}>
          Billing Report
        </Link>
      ),
    },
    {
      key: '/admin/user-feedback',
      label: (
        <Link
          to="/admin/user-feedback"
          id={TestSelectors.admin.nav.sections.userHelpRequest.toString()}
        >
          User Help Requests
        </Link>
      ),
    },
    {
      key: '/admin/user-credits',
      label: (
        <Link to="/admin/user-credits" id={TestSelectors.admin.nav.sections.userCredits.toString()}>
          User Credits
        </Link>
      ),
    },
    {
      key: '/admin/starter-tags',
      label: (
        <Link to="/admin/starter-tags" id={TestSelectors.admin.nav.sections.starterTags.toString()}>
          Starter Tags
        </Link>
      ),
    },
    {
      key: '/admin/log-level',
      label: (
        <Link to="/admin/log-level" id={TestSelectors.admin.nav.sections.logLevel.toString()}>
          Log Level
        </Link>
      ),
    },
    {
      key: '/admin/tracker-labels',
      label: (
        <Link
          to="/admin/tracker-labels"
          id={TestSelectors.admin.nav.sections.trackerLabels.toString()}
        >
          Tracker labels
        </Link>
      ),
    },
    {
      key: '/admin/feature-usage',
      label: (
        <Link
          to="/admin/feature-usage"
          id={TestSelectors.admin.nav.sections.featureUsage.toString()}
        >
          Feature Usage
        </Link>
      ),
    },
    { type: 'divider' },
    {
      key: 'impersonate-user',
      label: 'Impersonate user…',
      onClick: () => setImpersonateModalOpen(true),
    },
  ];

  return {
    items,
    impersonateUserModal: (
      <ImpersonateUserModal
        open={impersonateModalOpen}
        onClose={() => setImpersonateModalOpen(false)}
      />
    ),
  };
};
